<template>
  <div class='add'>
    <div class="YTitle">新增消息模板</div>

    <div class="from YFrom2">
      <el-form :model="formInline" :rules="rules" ref="rules" :label-width='`${ 200 / 192 }rem`'>
        <el-form-item label="消息标题：" prop="notifyTitle">
          <el-input v-model.trim="formInline.notifyTitle" placeholder="请输入消息标题"></el-input>
        </el-form-item>
        <el-form-item label="是否添加短信模板：" prop="isAddSmsTemplate">
          <el-radio-group v-model.trim="formInline.isAddSmsTemplate">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1" :disabled='formInline.templateType === 0'>是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="消息类型：" prop="notifyType">
          <el-radio-group v-model.trim="formInline.notifyType">
            <el-radio :label="0">公告</el-radio>
            <el-radio :label="1">消息提醒</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模板内容类型：" prop="templateType">
          <el-radio-group v-model.trim="formInline.templateType" @input="templateTypeInput">
            <el-radio :label="0">html</el-radio>
            <el-radio :label="1">text</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="消息模板：" prop="templateValue" v-if="formInline.templateType === 1">
          <el-input
            type="textarea"
            v-model.trim="formInline.templateValue"
            :placeholder='`消息模板定义参数规则：\${costemField}，customField为为自定义名字,必须为大小写字母\n例如：已收到\${username}发起的工单，请及时审批。`'
            :autosize="{ minRows: 4, maxRows: 4}">
          </el-input>
        </el-form-item>
        <el-form-item label="消息模板：" prop="templateValue" v-if="formInline.templateType === 0">
          <YWangEditor v-model="formInline.templateValue"></YWangEditor>
        </el-form-item>
      </el-form>
    </div>

    <div class="btn">
      <el-button type="primary" round @click="save">保存</el-button>
      <el-button plain round @click="close">取消</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/shared/api/apps/news'
export default {
  name: 'Add',

  data () {
    return {
      formInline: {
        notifyTitle: '',
        isAddSmsTemplate: 0,
        notifyType: 0,
        templateType: 0,
        templateValue: ''
      },
      rules: {
        notifyTitle: [
          { required: true, message: '请输入消息标题', trigger: 'blur' }
        ],
        isAddSmsTemplate: [
          { required: true, message: '请选择是否添加短信模板', trigger: 'blur' }
        ],
        notifyType: [
          { required: true, message: '请选择消息类型', trigger: 'blur' }
        ],
        templateType: [
          { required: true, message: '请选择模板内容类型', trigger: 'blur' }
        ],
        templateValue: [
          { required: true, message: '请输入消息模板', trigger: 'blur' }
        ]
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {},

    save () {
      this.$refs.rules.validate((valid) => {
        if (valid) {
          this.$confirm('是否保存该消息模板?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit()
          }).catch(() => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    submit () {
      const params = {
        method: api.add,
        notifyTitle: this.formInline.notifyTitle,
        isAddSmsTemplate: this.formInline.isAddSmsTemplate,
        notifyType: this.formInline.notifyType,
        templateType: this.formInline.templateType,
        templateValue: this.formInline.templateValue
      }

      this.axios.post(params).then(res => {
        if (res.data.backend_odc_notify_template_add_response.code !== '10000') return
        this.$message({
          message: '新增消息模板成功',
          type: 'success'
        })
        this.$emit('close', 1)
      })
    },

    templateTypeInput (val) {
      this.formInline.templateValue = ''
      if (val) return
      this.formInline.isAddSmsTemplate = 0
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang='stylus' scoped>
  .add
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background #ffffff
    z-index 1
    display flex
    flex-direction column
    .from
      flex auto
      margin-top 20px
    .btn
      margin 20px 0
      text-align center
</style>
